var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ hasHover: !_vm.isMobile, mobile: _vm.isMobile },attrs:{"id":"app"}},[(_vm.showNavigation)?_c('Navigation'):_vm._e(),_c('KeepAlive',{attrs:{"include":"WorksMobile"}},[_c('RouterView',{staticClass:"view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }